export default __webpack_public_path__ + "static/media/office.f82a9f0e.svg";